(function () {
  'use strict';

  /* ==========================================================================
     Cartes format (PDP) — v3, base propre.
     Architecture : les cartes sont un MIROIR du sélecteur natif Eurus.
     - Clic carte  → radio natif .click()  → Eurus fait TOUTE la mise à jour.
     - État visuel → lu en direct sur les radios COCHÉS (synchrone, aucune
       course réseau, aucun setTimeout). Un MutationObserver re-synchronise
       quand Eurus re-rend le picker après son fetch.
     ========================================================================== */

  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function getPicker(sectionId, root) {
    return (
      (root && root.querySelector('#variant-update-' + sectionId)) ||
      document.getElementById('variant-update-' + sectionId)
    );
  }

  function checkedValueIds(picker) {
    return qsa('input[data-option-value-id]', picker)
      .filter(function (i) { return i.checked; })
      .map(function (i) { return String(i.getAttribute('data-option-value-id')); });
  }

  function cardValueIds(card) {
    return (card.getAttribute('data-option-value-ids') || '').split(',').filter(Boolean);
  }

  /* Reflète l'état des radios cochés sur les cartes. */
  function mirror(cards, picker) {
    var ids = checkedValueIds(picker);
    if (!ids.length) return;
    cards.forEach(function (card) {
      var need = cardValueIds(card);
      var sel = need.length > 0 && need.every(function (id) { return ids.indexOf(id) > -1; });
      card.classList.toggle('is-selected', sel);
      card.setAttribute('aria-checked', sel ? 'true' : 'false');
    });
  }

  function inputsForCard(card, picker) {
    var inputs = [];
    cardValueIds(card).forEach(function (ovId) {
      var input = picker.querySelector('input[data-option-value-id="' + ovId + '"]');
      if (input) inputs.push(input);
    });
    return inputs;
  }

  function init(root) {
    if (root.dataset.muesliVcBound) return;
    root.dataset.muesliVcBound = '1';

    var sectionId = root.getAttribute('data-section-id');
    var cards = qsa('.variant-card', root);
    if (!sectionId || cards.length === 0) return;

    function picker() { return getPicker(sectionId, root); }

    function selectCard(card) {
      var p = picker();
      if (!p) return;
      var inputs = inputsForCard(card, p);
      inputs.forEach(function (input) {
        if (!input.checked) input.click(); /* déclenche le pipeline Eurus complet */
      });
      mirror(cards, p); /* lecture synchrone de l'état coché */
    }

    cards.forEach(function (card, idx) {
      card.addEventListener('click', function (e) {
        e.preventDefault();
        selectCard(card);
      });
      card.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          selectCard(card);
          return;
        }
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        var next = e.key === 'ArrowRight' ? idx + 1 : idx - 1;
        if (next < 0) next = cards.length - 1;
        if (next >= cards.length) next = 0;
        cards[next].focus();
        selectCard(cards[next]);
      });
    });

    /* Écouteurs sur le conteneur STABLE (.variant-selects) : Eurus remplace
       tout son innerHTML à chaque variante (_updateOptionValues), donc rien
       ne doit être attaché aux nœuds internes (picker, radios). */
    var container = (function () {
      var p0 = picker();
      return (p0 && p0.closest('.variant-selects')) || document.getElementById('variant-selector');
    })();
    if (container) {
      /* délégation : tout change de radio remonte ici, même après re-rendu */
      container.addEventListener('change', function () {
        var p = picker();
        if (p) mirror(cards, p);
      });
      /* re-rendu du picker par Eurus → re-miroir (les radios re-rendus sont
         re-cochés par Eurus selon la variante à jour) */
      var pending = false;
      new MutationObserver(function () {
        if (pending) return;
        pending = true;
        requestAnimationFrame(function () {
          pending = false;
          var p = picker();
          if (p) mirror(cards, p);
        });
      }).observe(container, { childList: true, subtree: true });
    }

    /* Le pipeline Eurus n'existe qu'une fois le composant Alpine monté :
       cliquer un radio avant = clic dans le vide (bouton/Appstle jamais
       notifiés). On ne présélectionne donc que quand Eurus est prêt. */
    function eurusReady() {
      try {
        var el = container && container.closest ? container : document.getElementById('variant-selector');
        var d = window.Alpine && el && window.Alpine.$data(el);
        return !!(d && typeof d.updateVariantSelector === 'function');
      } catch (e) { return false; }
    }
    function whenEurusReady(fn) {
      if (eurusReady()) { fn(); return; }
      var done = false;
      var run = function () {
        if (done || !eurusReady()) return;
        done = true;
        fn();
      };
      document.addEventListener('alpine:initialized', run, { once: true });
      var tries = 0;
      var timer = setInterval(function () {
        if (eurusReady() || tries++ > 60) {
          clearInterval(timer);
          run();
        }
      }, 100);
    }

    /* État initial : présélection (carte data-default) si aucune variante
       explicite dans l'URL, sinon simple miroir de l'état courant. */
    var urlVariant = new URL(window.location.href).searchParams.get('variant');
    var defaultCard = root.querySelector('.variant-card[data-default="true"]');
    var p0 = picker();
    if (!urlVariant && defaultCard && p0) {
      var already = inputsForCard(defaultCard, p0).every(function (i) { return i.checked; });
      if (!already) {
        whenEurusReady(function () { selectCard(defaultCard); });
        if (p0) mirror(cards, p0);
        return;
      }
    }
    if (p0) mirror(cards, p0);
  }

  function boot() {
    qsa('[data-muesli-variant-cards-root]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
